export const EMPTY_LABEL = '--';

/**
 * 股票代码处理, 获取股票ID
 * 例如分割小数点取除最后位市场标志
 * 00700.HK => 00700
 * SHHK07.IDX.HK => SHHK07
 * NSPR+B.US => NSPR+B
 * @param {string} data 股票代码完整的股票代码
 */
 export function getAssetIdByStockCode(data) {
  if (!data) return EMPTY_LABEL;
  const arr = data.split('.');
  arr.pop();
  return arr.join('.');
}


// 返回股票最后市场标签 - 大写 data：string, 如00700.HK, 得到HK
export function getMarketLabl(data) {
  if (!data) return '';
  const assetIdArr = data.split('.');
  return assetIdArr.pop().toUpperCase();
}

// 返回股票不携带市场标签 代码， 如 SHHK07.IDX.HK => SHHK07.IDX
export function getStockCode(data) {
  if (!data) return '';
  const lastInd = data.lastIndexOf('.');
  return data.substring(0, lastInd);
}

// 返回不携带前缀 0 的股票代码  如0700 => 700
export function getStkDelZero(stkCode) {
  if (!stkCode) return '';
  return stkCode.replace(/^0+/g, '');
}